import React, { useEffect, useState, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// assets
import CustomIcons from 'components/CustomIcons';

//components
import SearchForm from 'components/SearchForm';
import AddNewIconButton from 'components/AddNewIconButton';
import { FilterOptions } from 'components/DynamicSideList/components';

// utils
import api from 'utils/api';
// hooks
import { useAuthRole } from 'utils/hooks';
import _local from 'utils/localStorageUtils';


const CommunicationsHeadlineBar = ({
  // default
  title,
  loading,
  search,
  filter,
  params,
  // actions
  onFilter,
  onReset,
  onSearch,
  onAdd,
  // root
  className
}) => {
  const childClassNames = classNames('communication-headline-bar', className);
  const { t } = useTranslation();

  const contextChild =  _local.getLocalChild();

  const [showSearch, setShowSearch] = useState(search?.length > 0 || false);
  const [showFilter, setShowFilter] = useState(filter?.length > 0 || false);

  const [optionsForFilter, setOptionsForFilter] = useState([]);


  useEffect(() => {
    // load items for filtering
    optionsForFilter?.length <= 0 && api.communications.fetchAllTypes().then(result => {
      let emptyResult = [
        {
          key: 'types',
          name: 'types',
          group: [
            {
              key: 'types',
              label: t("labels.types"),
              name: 'types-all',
              value: 'types-all',
            },
          ],
        },
      ];
      if (result.length > 0) {
        setOptionsForFilter(result);
      } else {
        setOptionsForFilter(emptyResult);
      }
    });

    return () => {
    };
  }, []);

  useEffect(() => {
    if (!!params) {
      !!params?.filterValue && setShowFilter(params?.filterValue?.length > 0);
      if (!!params?.searchStr) {
        setShowSearch(params?.searchStr?.length > 0);
      }
    } 
  }, [params]);

  useEffect(() => {
    if (!!contextChild?._id) {
      setShowFilter(false)
      setShowSearch(false);
    } 
  }, [contextChild?._id]);

  const filterIconRendering = useMemo(() => {
    return (
      <CustomIcons
        className={`filter-extra__icon filter-icon ${showFilter || filter?.length > 0 ? 'show' : ''
          } ${loading ? 'disabled' : ''}`}
        type="filter"
        onClick={() => setShowFilter(prev => !prev)}
      />
    );
  }, [loading, showFilter, filter]);

  return (
    <div className={childClassNames}>

      <div className="headline">
        <h3 className="headline-title">{!!title && title || t("labels.communications")}</h3>
        <div className="communication-actions-bar">
          {filterIconRendering}
          <SearchForm
            uniqueKey="search-communication-mobile"
            value={search}
            loading={loading}
            show={showSearch}
            setShow={setShowSearch}
            onSearch={onSearch}
            onClose={value => {
              if (value?.length > 0) {
                !!onSearch && onSearch('');
              }
            }}
          />
          {!!useAuthRole(['parent']) && !!onAdd && (
            <AddNewIconButton
              className="float-add-communication"
              onClick={onAdd}
              disabled={!!!contextChild?._id}
            />
          )}
        </div>
      </div>

      <div className="headline-actions">
        {!!showFilter && (
          <>
            <FilterOptions
              uniqueKey="mobile-filter-communication"
              className="mobile-filtration"
              view="tags"
              showIcon={false}
              value={filter}
              loading={loading}
              options={optionsForFilter}
              show={showFilter}
              setShow={setShowFilter}
              onFilter={onFilter}
              onReset={onReset}
            />
          </>
        )}
      </div>
    </div>
  );
};

CommunicationsHeadlineBar.defaultProps = {
  loading: false,
  search: '',
};

export default CommunicationsHeadlineBar;
